import React, { useEffect, useState } from "react";
import './styles/about.css';
import about from './styles/images/Section-about.jpg';
import mission from './styles/images/Section-mission.jpg';
import mission1 from './styles/images/Section-mission1.jpg';
import Static from './styles/images/service-icon.png';
import animated from './styles/images/output-onlinegiftools.gif';
import wabes from './styles//images/download.svg';
import Testimonial from "./Testimonial";
import Footer from "./Footer";
import reviving from './styles/images/revviving.png';
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdBusiness } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";
import AOS from "aos";
import "aos/dist/aos.css";
function About() {
    useEffect(() => {
        AOS.init({
          duration: 1000,  // Animation duration
          easing: 'ease',  // Easing function
          once: false,    // Re-run animations when scrolling back
        });
      }, []);
    //https://x.com/share?text=Electronic+Visit+Verification+%28EVV%29&url=https%3A%2F%2Fbestcaremn.com%2Fresource%2Fevv%2F
    //
    //
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [review, setReview] = useState([]);
    const [visibleReviews, setVisibleReviews] = useState(3);
    const [isExpanded, setIsExpanded] = useState(false);
        const insuranceData = [
          { name: "BV Bridgeview", address: "525 South Lake Avenue, Suite 2 Duluth, MN 55802" },
          { name: "BluePlus Blue Cross Blue Shield Medicaid", address: "PO BOX 64338 Saint Paul, MN 55164" },
          { name: "HP Health Partners", address: "8170 33rd Ave S Bloomington, MN 55425" },
          { name: "MA Minnesota Dept. of Human Service", address: "444 Layfayette Road Saint Paul, MN 55155" },
          { name: "Prime West", address: "822 South 3rd Street Ste 150 Minneapolis, MN 55415" },
          { name: "South Country Health Alliance", address: "C/O MMSI PO Box 4014 Rochester, MN 55901" },
          { name: "UCare", address: "PO BOX 52 Saint Paul, MN 55440" },
        ];
    
        useEffect(() => {
            fetchReviews();
        }, []);
       
        const fetchReviews = async () => {
            try {
                const response = await axios.get('https://samahomecare.com/api/fetch.php');
    
                if (response.data.success) {
                    setReview(response.data.reviews || []); // Ensure it's always an array
                } else {
                    toast.error(response.data.message || 'No data received');
                }
            } catch (e) {
                console.error("Error fetching reviews:", e);
                setError("Error fetching reviews!");
                toast.error("Error fetching reviews!");
            } finally {
                setLoading(false);
            }
        };
        const handleViewMore = () => {
            setVisibleReviews((prev) => prev + 3);// Show 3 more reviews on button click
            setIsExpanded(true);
            setTimeout(() => {
                document.querySelectorAll('.review-card').forEach((card) => {
                    card.classList.remove('hidden'); // Remove hidden class for smooth animation
                });
            }, 100);
        };
    return(
        <>
        <section id="about" className="about">
        <div className="wrap"></div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">
                        <h1 className="heading"> <span className="hero-highlight"> CARING </span> BEYOND LIMITS – <br /> <span className="hero-highlight"> DEDICATED</span> TO YOUR COMFORT</h1>
                        <p className="supporting">
                        Because your loved ones deserve the best—compassionate care, unwavering support, and a home filled with comfort and dignity.
                            </p>
                    </div>
                </div>
            </div>
              <img src={wabes} alt="Waves" id="waves1" />
        </section>
        <section id="about-desc">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7 col-md-6 col-sm-12">
                        <h2>
                            Why<strong> <span className="hero-highlight">Samah Home Care</span></strong> ?
                        </h2>
                        <p>
                        Samah Home Care is dedicated to providing compassionate, high-quality in-home care services tailored to meet the unique needs of each client. Our mission is to enhance the quality of life for seniors and individuals with disabilities by offering personalized care that promotes independence, dignity, and well-being. With a team of skilled caregivers, we ensure a safe and comfortable environment, assisting with daily activities, medical needs, and emotional support. At Samah Home Care, we believe in treating every client like family, delivering professional care with warmth, respect, and reliability. Whether it’s companionship, skilled nursing, or specialized care, we are committed to being a trusted partner in health and wellness.
                        </p>
                    </div>
                    <div className="col-lg-5 col-md-6 col-sm-12">
                        <img src={about} alt="About"  id="about-img"/>
                    </div>
                </div>
            </div>
        </section>
        <section id="mission">
            <div className="container">
                <div className="row py-4">
                <div className="col-lg-12 col-md-12 col-sm-12 ">
                    <h1 className="mb-5 border-bottom pb-3">
                    Committed to <span className="hero-highlight"> excellence </span>, <br /> Dedicated to your <span className="hero-highlight">well-being</span>
                    </h1>
                </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12" id="mission-col">
                        <div className="about-img">
                            <img src={mission} alt="No One cares whats uploaded" id="mission-img" />
                        </div>
                        <div className="about-text">
                            <h2 className="py-3 " >  Our <span className="hero-highlight"> Mission </span> </h2>
                            <p className="supporting py-2">
                            At Samah Home Care, our mission is to provide compassionate, high-quality, and personalized care that enhances the well-being and independence of our clients. We are dedicated to creating a safe, nurturing environment where individuals receive the support they need with dignity, respect, and empathy. Our goal is to make a meaningful difference in the lives of seniors and those in need by delivering exceptional home care services with professionalism and warmth.                            </p>
                            <div className="Mission-links">
                                <li className="hero-btn1">
                                    <h4> 
                                        <img src={animated} alt="no one care there is a ALT -SAmah home CAre" id="Animated" />
                                        <img src={Static} alt="no one care there is a ALT -SAmah home CAre" id="Static" />
                                    Compassionate Care
                                    </h4>
                                   
                                   
                                </li>
                                <li  className="hero-btn1">
                                    <h4>
                                    <img src={animated} alt="no one care there is a ALT -SAmah home CAre" id="Animated" />
                                    <img src={Static} alt="no one care there is a ALT -SAmah home CAre" id="Static" />
                                    Professional Excellence
                                    </h4>
                                   
                                   
                                </li>
                                <li  className="hero-btn1">
                                    <h4>
                                    <img src={animated} alt="no one care there is a ALT -SAmah home CAre" id="Animated" />
                                    <img src={Static} alt="no one care there is a ALT -SAmah home CAre" id="Static" />
                                    Client-Centered Approach
                                    </h4>
                                </li>
                            </div>
                        </div>
                    </div>
                   
                </div>
                <div className="row mt-5">
                    <div className="col-lg-12 col-md-12 col-sm-12" id="mission-col">
                      
                        <div className="about-text1">
                            <h2 className="py-3 " >  Our <span className="hero-highlight"> Values </span> </h2>
                            <p className="supporting py-2">
                            At Samah Home Care, our values are rooted in compassion, respect, and excellence. We are committed to delivering high-quality, personalized care that prioritizes the dignity, independence, and well-being of our clients. Integrity, empathy, and professionalism guide our every action, ensuring a nurturing and supportive environment. By fostering trust and building meaningful relationships, we strive to make a positive impact in the lives of those we serve.
                             </p>
                            <div className="Mission-links">
                                <li className="hero-btn1">
                                    <h4> 
                                        <img src={animated} alt="no one care there is a ALT -SAmah home CAre" id="Animated" />
                                        <img src={Static} alt="no one care there is a ALT -SAmah home CAre" id="Static" />
                                        Empathy & Respect
                                    </h4>
                                   
                                   
                                </li>
                                <li  className="hero-btn1">
                                    <h4>
                                    <img src={animated} alt="no one care there is a ALT -SAmah home CAre" id="Animated" />
                                    <img src={Static} alt="no one care there is a ALT -SAmah home CAre" id="Static" />
                                    Commitment to Excellence
                                    </h4>
                                   
                                   
                                </li>
                                <li  className="hero-btn1">
                                    <h4>
                                    <img src={animated} alt="no one care there is a ALT -SAmah home CAre" id="Animated" />
                                    <img src={Static} alt="no one care there is a ALT -SAmah home CAre" id="Static" />
                                    Personalized Support 
                                    </h4>
                                </li>
                            </div>
                        </div>
                          <div className="about-img">
                            <img src={mission1} alt="No One cares whats uploaded" id="mission-img1" />
                        </div>
                    </div>
                   
                </div>
            </div>
        </section>
        <br /><br />
        <section >
            <div className="container" style={{fontFamily: 'Montserrat'}}>
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 border-bottom">
                        <h1 className="py-3" id="certifications">
                            Certifications
                        </h1>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-4 col-md-6 col-sm-12">
                    <div class="card4">
                    <i class="fas fa-check-circle"></i>
            <h3>CFSS Certified</h3>
        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                    <div class="card4">
                    <i class="fas fa-check-circle"></i>
            <h3>National Women's Business Enterprise</h3>
        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                    <div class="card4">
                    <i class="fas fa-check-circle"></i>
            <h3>North Central Minority Supplier Development</h3>
        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="testimonial-about" >
        <img src={wabes} alt="Waves" id="waves" />
            <div className="container">
                <div className="row mb-5 test-row">
                <h1>What Our <span>Clients</span> Say:</h1>
                </div>
                
            </div>
            
            </section>
            <div className="row">
                    <div className="col-lg-12 co-md-12 col-sm-12">
                    <Testimonial />
                    </div>
                </div>
            <section className="evv-section py-5">
                <div className="container">
                    <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                            <h2 className="display-5 mb-4" style={{ fontWeight: '600', color: '#2c3e50' }} data-aos="fade-up" >
                                Embrace the Future of Caregiving with EVV
                            </h2>
                            <p className="lead mb-4" style={{ color: '#34495e' }} data-aos="fade-up">
                                Starting <strong>September 1, 2024</strong>, the Minnesota Department of Human Services (DHS) requires all caregivers to use <strong>Electronic Visit Verification (EVV)</strong> systems for documenting in-home and community-based services. This ensures transparency, accuracy, and compliance with state regulations.
                            </p>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        {/* Left Column: Image Placeholder */}
                        <div className="col-lg-5 col-md-5 col-sm-12">
                            <div className="image-placeholder" >
                                {/* Replace this div with an actual image */}
                                <img
                                    src={reviving}
                                    alt="EVV App Illustration"
                                    className="img-fluid rounded"
                                    data-aos="fade-up"
                                />
                            </div>
                        </div>
                        <div className="col-lg-7 col-sm-12 col-md-7" id="rev-why" data-aos="fade-up">
                            <p className="mb-4" style={{ color: '#34495e' }} data-aos="slide-up">
                                At <strong>Samah Home Care</strong>, we’ve partnered with <strong><a href="https://revivingcare.com">RevivingCare</a></strong>, a cutting-edge EVV solution designed to simplify your workflow. Our app is compatible with smartphones, tablets, and computers, making it easy for caregivers to stay compliant while focusing on what matters most—providing exceptional care.
                            </p>
                            <div className="Rev-links" data-aos="slide-up">
                                <a
                                    href="https://apps.apple.com/pk/app/revivingcare-evv/id6503343244."
                                    className="btn btn-primary btn-lg"
                                    style={{ backgroundColor: '#3498db', border: 'none', borderRadius: '8px' }}
                                >
                                    Download for iOS
                                </a>
                                <a data-aos="slide-up"
                                    href=" https://play.google.com/store/apps/details?id=com.evv.revivingcare.rc&hl=en
"
                                    className="btn btn-primary btn-lg"
                                    style={{ backgroundColor: '#038cfb', border: 'none', borderRadius: '8px', }}
                                >
                                    Download for Android
                                </a>
                            </div>
                            <div className="evv-links">
                            <ul class="wrapper">
  <li class="icon facebook">
    <span class="tooltip">Facebook</span>
    <svg
      viewBox="0 0 320 512"
      height="1.2em"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      ></path>
    </svg>
  </li>
  <li class="icon twitter">
    <span class="tooltip">Twitter</span>
    <svg
      height="1.8em"
      fill="currentColor"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      class="twitter"
    >
      <path
        d="M42,12.429c-1.323,0.586-2.746,0.977-4.247,1.162c1.526-0.906,2.7-2.351,3.251-4.058c-1.428,0.837-3.01,1.452-4.693,1.776C34.967,9.884,33.05,9,30.926,9c-4.08,0-7.387,3.278-7.387,7.32c0,0.572,0.067,1.129,0.193,1.67c-6.138-0.308-11.582-3.226-15.224-7.654c-0.64,1.082-1,2.349-1,3.686c0,2.541,1.301,4.778,3.285,6.096c-1.211-0.037-2.351-0.374-3.349-0.914c0,0.022,0,0.055,0,0.086c0,3.551,2.547,6.508,5.923,7.181c-0.617,0.169-1.269,0.263-1.941,0.263c-0.477,0-0.942-0.054-1.392-0.135c0.94,2.902,3.667,5.023,6.898,5.086c-2.528,1.96-5.712,3.134-9.174,3.134c-0.598,0-1.183-0.034-1.761-0.104C9.268,36.786,13.152,38,17.321,38c13.585,0,21.017-11.156,21.017-20.834c0-0.317-0.01-0.633-0.025-0.945C39.763,15.197,41.013,13.905,42,12.429"
      ></path>
    </svg>
  </li>
  <li class="icon instagram">
    <span class="tooltip">Instagram</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1.2em"
      fill="currentColor"
      class="bi bi-instagram"
      viewBox="0 0 16 16"
    >
      <path
        d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
      ></path>
    </svg>
  </li>
</ul>

                            </div>
                        </div>
                       
                    </div>
                  
                </div>
            </section >
            <div className="container" style={{fontFamily: 'Montserrat'}}>
                <div className="row border-bottom mb-4">
                    <div className="col-lg-12 col-md-12 col-sm-12 p-4
                    ">
                        <h1>
                            <span className="hero-highlight">Health Plans</span> We <strong> Serve</strong>
                        </h1>
                    </div>
                </div>
            </div>
            <section class="insurance-container">
        <div class="card3">
            <i class="fas fa-building icon"></i>
            <h3>BV Bridgeview</h3>
            <p>525 South Lake Avenue, Suite 2 Duluth, MN 55802</p>
        </div>

        <div class="card3">
            <i class="fas fa-building icon"></i>
            <h3>BluePlus Blue Cross Blue Shield Medicaid</h3>
            <p>PO BOX 64338 Saint Paul, MN 55164</p>
        </div>

        {/* <div class="card3">
            <i class="fas fa-building icon"></i>
            <h3>HP Health Partners</h3>
            <p>8170 33rd Ave S Bloomington, MN 55425</p>
        </div> */}

        <div class="card3">
            <i class="fas fa-building icon"></i>
            <h3>MA Minnesota Dept. of Human Service</h3>
            <p>444 Layfayette Road Saint Paul, MN 55155</p>
        </div>

        <div class="card3">
            <i class="fas fa-building icon"></i>
            <h3>Prime West</h3>
            <p>822 South 3rd Street Ste 150 Minneapolis, MN 55415</p>
        </div>

        <div class="card3">
            <i class="fas fa-building icon"></i>
            <h3>South Country Health Alliance</h3>
            <p>C/O MMSI PO Box 4014 Rochester, MN 55901</p>
        </div>

        {/* <div class="card3">
            <i class="fas fa-building icon"></i>
            <h3>UCare</h3>
            <p>PO BOX 52 Saint Paul, MN 55440</p>
        </div> */}
    </section>
            <section id="Reviews-section1">
                <div className="container">
                    {/* <div className="row">
                        <div className="col-md-12"> 
                            <h1>
                                Area we provide Service 
                            </h1>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                        

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 col-md-12" id="Review-header">
                            <h1>
                                Hear From Our Happy <span className="hero-highlight"> Clients</span>
                            </h1>
                            <p>
                           "Authentic testimonials from those who have benefited from our compassionate care."
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-sm-12 col-md-12" id="Review-body">

                            <h2>Customer Reviews</h2>
                            {loading ? (
                                <p>Loading reviews...</p>
                            ) : error ? (
                                <p style={{ color: 'red' }}>{error}</p>
                            ) : review.length > 0 ? (
                                <div className="review-list">
                                    {review.slice(0, visibleReviews).map((item) => (
                                        <div key={item.id} className="review-card">
                                            <div className="card-header">
                                                <h6>  <p>Name:</p> {item.name}</h6>

                                                <p>
                                                   Company: {item.company}
                                                </p>
                                                <p>Rating: {"⭐".repeat(item.header)} ({item.header}/5)</p>
                                                <p className="timestamp">Added on: {new Date(item.created_at).toLocaleString()}</p>
                                            </div>
                                            <div className="card-foot">
                                                <h1><strong>{item.main_line}</strong></h1>
                                                <p>Review: </p>
                                                <p >{item.reviewtext}</p>
                                                
                                                
                                            </div>
                                        </div>
                                    ))}
                                    {visibleReviews < review.length && !isExpanded && (
                                        <button className="btn btn-primary" onClick={handleViewMore}>
                                            View More
                                        </button>
                                    )}
                                    {isExpanded && (
                                        <>
                                            <button className="btn btn-primary" onClick={() => {
                                                setVisibleReviews(3);
                                                setIsExpanded(false);
                                            }}>
                                                View less
                                            </button>
                                        </>
                                    )

                                    }
                                </div>
                            ) : (
                                <p>No reviews yet. Be the first to leave one!</p>
                            )} 

                      </div>
                 </div>
                </div>
            </section>

            <footer>
                <Footer />
            </footer>
        </>
    )
}

export default About;